module.exports = __webpack_public_path__ + "../resources/img/ic_in_progress_number_3.f9aae259.svg";